/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
//@ts-nocheck
import React, { useEffect, useState } from "react";
import { Form, InputGroup } from "react-bootstrap";
import * as S from "../../styles";

export interface IRadioButtonProps {
    id: string;
    label?: string;
    value?: string;
    errorText?: string;
    disabled?: boolean;
    readOnly?: boolean;
    options?: { id: string; label: string }[];
    required?: boolean;
    placeholder?: string;
    direction?: "horizontal" | "vertical";
    labelColor?: string;
    onCompChange?(id: string, payload: any): void;
    hasError?: boolean;
}

export const RadioButton = ({
    id,
    label,
    disabled,
    errorText,
    value,
    required,
    options,
    onCompChange,
    labelColor,
    hasError,
    direction,
    readOnly,
}: IRadioButtonProps) => {
    const [item, setItem] = useState({ textValue: value ?? "" });
    const [isInvalid, setInvalid] = useState(false);

    useEffect(() => {
        if (hasError) {
            setInvalid(true);
        }
    }, [hasError]);
    // const [textValue, setTextValue] = useState(value ?? "");
    const onChange = (id: string, e: any) => {
        if (disabled || readOnly) {
            return;
        }
        setItem((prevState) => ({
            ...prevState,
            textValue: e?.target?.value,
        }));
        onCompChange && onCompChange(id, e?.target?.value);
    };
    const _renderLabelIf = () => {
        if (label) {
            return (
                <S.FormLabel color={labelColor}>
                    {label}
                    {required && <sup style={{ color: "red" }}>*</sup>}
                </S.FormLabel>
            );
        }
        return null;
    };

    const _renderErrorTextIf = () => {
        if (hasError && errorText) {
            return (
                <S.FeedbackOtherLabel type="tooltip">
                    {errorText}
                </S.FeedbackOtherLabel>
            );
        }
        return null;
    };
    const { textValue } = item;
    const Comp = direction === "horizontal" ? InputGroup : React.Fragment;
    return (
        <>
            <Form.Group id={id} className="mb-4 formgroup">
                {_renderLabelIf()}
                <Comp className="mx-2">
                    {options?.map((option, index) => (
                        <Form.Check
                            className="formcheck form-check-radio mt-1 mb-1"
                            type={"radio"}
                            label={option?.label}
                            aria-label={`radio-${index + 1}`}
                            value={option.id}
                            onChange={onChange.bind(null, id)}
                            checked={textValue === option.id}
                            key={`radio-button-option-${option?.id}-${index}`}
                            readOnly={readOnly}
                            isInvalid={isInvalid}
                            disabled={disabled}
                        />
                    ))}
                    {direction === "horizontal" ? (
                        _renderErrorTextIf()
                    ) : (
                        <InputGroup>{_renderErrorTextIf()}</InputGroup>
                    )}
                </Comp>
            </Form.Group>
        </>
    );
};

RadioButton.defaultProps = {
    direction: "horizontal",
    required: false,
    rootColor: "grey",
    pointColor: "#000000",
    hasError: false,
    disabled: false,
    readOnly: false,
};
